module.exports = __webpack_public_path__ + "img/060-benin.2ebad683.svg";